import React from "react";
import { useTranslation } from "react-i18next";
import BadgeBoxCst from "@components/BadgeBoxCst";
import { resolveScoStatus } from "../config/scoStatusConfig";

interface ScoStatusBadgeProps {
  status?: string | null;
}

const ScoStatusBadge: React.FC<ScoStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation("enrollment-progress");
  const definition = resolveScoStatus(status);

  return (
    <BadgeBoxCst variant={definition?.variant ?? "default"}>
      {definition ? t(`sco-status.${definition.labelKey}`) : status || "-"}
    </BadgeBoxCst>
  );
};

export default ScoStatusBadge;
